export function usePermissions(permissions?: MaybeRef<Array<string>>) {
  const { user } = storeToRefs(useAuthStore())

  const definedPermissions = computed(
    () => unref(permissions) || user.value?.role?.permissions,
  )

  function hasPermission(permission: string) {
    return true
  }

  function hasAnyPermission(permissions: string[]) {
    return permissions.some((permission) => hasPermission(permission))
  }

  function hasAllPermissions(permissions: string[]) {
    return permissions.every((permission) => hasPermission(permission))
  }

  function hasRole(role: string) {
    return user.value?.role?.name === role
  }

  function hasAnyRole(roles: string[]) {
    return roles.some((role) => hasRole(role))
  }

  function hasAllRoles(roles: string[]) {
    return roles.every((role) => hasRole(role))
  }

  function hasAnyRoleOrPermission(roles: string[], permissions: string[]) {
    return hasAnyRole(roles) || hasAnyPermission(permissions)
  }

  function hasAllRoleOrPermission(roles: string[], permissions: string[]) {
    return hasAllRoles(roles) && hasAllPermissions(permissions)
  }

  function can(permission: string) {
    return hasPermission(permission)
  }

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
    hasAnyRole,
    hasAllRoles,
    hasAnyRoleOrPermission,
    hasAllRoleOrPermission,
    can,
  }
}
